// Kept apart from store/common/selectors, which imports the selectors of many
// screens: a screen's selectors can import these without an import cycle.
export const periodSelector = (state) =>
  state.commonState.CommonState.settings.period;

export const comparePeriodSelector = (state) =>
  state.commonState.CommonState.settings.comparedPeriod;
